
import {userApi} from '@/api';
import {Vue, Component, Emit} from 'vue-property-decorator';
import {message} from 'ant-design-vue';

import moment from 'moment';
import {getDomainHandle} from '@/js/domainUtils';
import PrivacyAgreement from './privacy-agreement.vue';
@Component({
    components: {PrivacyAgreement},
    beforeRouteEnter: (to, from, next) => {
        if (to.query.loginToken) {
            // console.log(to.query.loginToken);
            const getUserInfoFn = (token: any) => {
                /** 获取用户信息 http://yapi.dm-ai.cn:3000/project/163/interface/api/3425 */
                let url = '/api/v1/user/info';
                fetch(url, {
                    method: 'GET',
                    headers: new Headers({
                        Authorization: 'Bearer ' + token
                    })
                })
                    .then(res => res.json())
                    .then(data => {
                        if (data.code == 0) {
                            let userInfo = data.data;
                            // 手动将 token 添加到 userInfo 中
                            userInfo['token'] = token;
                            next(vm => {
                                // 通过 `vm` 访问组件实例
                                vm.$app.setToken(token);
                                vm.$app.setState(userInfo);
                                vm.$router.replace({
                                    path: '/home'
                                });
                            });
                        } else {
                            next();
                        }
                    })
                    .catch(res => {
                        message.error('凭证过期或者网络异常，请重新登录');
                        next();
                    });
            };
            /**
             * 根据跳转凭证获取token http://yapi.dm-ai.cn:3000/project/163/interface/api/7800
             */
            let url = '/api/v1/user/jump/token' + '?ticket=' + to.query.loginToken;
            fetch(url, {
                method: 'GET'
            })
                .then(res => res.json())
                .then(data => {
                    if (data.code == 0) {
                        let token = data.data;
                        getUserInfoFn(token);
                    } else {
                        message.error('凭证过期或者网络异常，请重新登录');
                        next();
                    }
                })
                .catch(res => {
                    message.error('凭证过期或者网络异常，请重新登录');
                    next();
                });
        } else {
            next();
        }
    }
})
export default class Home extends Vue {
    loginLogoUrl = getDomainHandle('loginLogoUrl');
    domainClassName = getDomainHandle('className');
    codeSvg = '';
    captchaKey = '';
    form: any = {
        username: '',
        password: '',
        code: ''
    };
    formRules: any = {
        username: [
            {
                required: true,
                message: '请输入用户名',
                trigger: 'change'
            }
        ],
        password: [
            {
                required: true,
                message: '请输入密码',
                trigger: 'change'
            }
        ],
        code: [
            {
                required: true,
                message: '请输入验证码',
                trigger: 'change'
            }
        ]
    };
    autoLogin: boolean = false;
    errorLogin: boolean = false;
    errorCode: boolean = false;
    errorAccount: boolean = false;
    errorPassword: boolean = false;
    isAgree = false;

    demoMethods() {
        console.log('demo1');
    }
    viewDemo(id: string) {
        this.$router.replace({
            path: '/demo/home',
            query: {}
        });
    }
    login() {
        if (!this.isAgree) {
            this.$message.warn('请先勾选并阅读同意协议');
            return;
        }
        (this.$refs.formRules as any).validate((valid: any) => {
            if (!!valid === false) {
                console.log('error...........');
                return;
            }
            if (!this.form.username || !this.form.password) {
                return;
            }
            //去除账号密码两头的空格
            this.form.username = this.form.username.replace(/^\s*|\s*$/g, '');
            this.form.password = this.form.password.replace(/^\s*|\s*$/g, '');

            console.log('login');
            let me = this;
            userApi.login({
                context: me,
                data: {
                    username: this.form.username,
                    password: this.form.password,
                    code: this.form.code,
                    captchaKey: this.captchaKey
                },
                success(data: any, parameters: any) {
                    let domain = data;
                    domain.autoLogin = me.autoLogin;
                    domain.password = me.form.password;

                    me.$app.setToken(domain.token);
                    me.$app.setState(domain);

                    if (me.form.password === '123456') {
                        me.$router.replace({
                            path: '/change-password',
                            query: {username: me.form.username}
                        });
                        return;
                    }
                    me.$router.replace({
                        path: '/home'
                    });
                },
                error(data: any, message: string, parameters: any) {
                    me.reloadCaptcha();
                    if (data.code === 90005) {
                        // 账号不存在
                        // me.errorLogin = true;
                        me.$message.warning('该账号不存在，请联系上级管理员处理。');
                    } else if (data.code === 90004) {
                        // 密码错误
                        me.errorPassword = true;
                    } else if (data.code === 90000) {
                        // 验证码错误
                        me.errorCode = true;
                    } else if (data.code === 90017) {
                        // 账号过期
                        me.$message.warning('该账号已过期，请联系上级管理员处理。');
                    } else if (data.code === 90019) {
                        // 账号未生效
                        let time = moment(data.error).format('YYYY年MM月DD日');
                        me.$message.warning(`账户暂不可用，将从${time}开始生效，届时请登录使用。`);
                    } else if (data.code === 90003) {
                        // 账号过期
                        me.$message.warning('该账号不存在，请联系上级管理员处理。');
                    } else {
                        // 账号错误
                        me.errorAccount = true;
                    }
                }
            });
        });
    }
    getCaptcha() {
        let me = this;
        userApi.getGraphicCode({
            context: me,
            success(data: any, parameters: any) {
                me.captchaKey = data.data.captchaKey;
                me.codeSvg = data.data.imageData;
            }
        });
    }
    reloadCaptcha() {
        let me = this;
        userApi.refreshGraphicCode({
            context: me,
            urlParams: {captchaKey: me.captchaKey},
            success(data: any, parameters: any) {
                me.codeSvg = data.data.imageData;
            }
        });
    }
    intoReset() {
        this.$router.replace({
            path: '/forget-password',
            query: {}
        });
    }
    cleanAccountError() {
        this.errorAccount = false;
        this.errorLogin = false;
    }
    cleanPasswordError() {
        this.errorPassword = false;
    }
    cleanCodeError() {
        this.errorCode = false;
    }
    created() {
        let params = this.$route.params;
        this.form.username = params?.username ?? '';
        this.form.password = params?.password ?? '';
        let me = this;
        let user = this.$app.getState();
        this.autoLogin = user.autoLogin;
        this.getCaptcha();
        if (user && user.autoLogin) {
            this.form.username = user.username;
            this.form.password = user.password;
            this.$nextTick(function () {
                me.login();
            });
        }
    }
    mounted() {}
}
